import React from 'react'
import { withNullErrorBoundary } from '../../../../utils'
import ShippingMethods from './shipping-methods'
import { motion } from '../../../motion'
import FormCheckboxOption from '../../../form/form-checkbox-option'
import { useSelector } from 'react-redux'
import { setShippingNotificationsEnabled } from '../../../../store/reducers/slices/checkout'
import { dispatch } from '../../../../store'
import ShippingNotifications from './shipping-notifications'

const ShippingOptions = () => {
  const shippingNotificationsEnabled = useSelector(state => state.checkout.form.shippingNotificationsEnabled)
  const onShippingNotificationsChange = (val) => {
    dispatch(setShippingNotificationsEnabled(val))
  }

  return (
    <>
      <div className="d-flex align-items-center justify-content-between">
        <label className="label">Shipping options:</label>
        <div className="readmore-wrp">
          <a href="/terms" className="read-more" target="_blank" rel="noopener noreferrer">learn more</a>
        </div>
      </div>

      <div className="col-12 in-line shipping-option">
        <ShippingMethods />
      </div>

      <motion.div layout className="col-12">
        <FormCheckboxOption checked={shippingNotificationsEnabled} onChange={onShippingNotificationsChange} type="checkbox" containerClass="shipping-notification-wrp" value="Enable SMS shipping notifications" uniqueName="enableShippingNotifications" className="form-check">
          {({ id }) => (
            <label className="form-check-label confirm" htmlFor={id}>
              Enable SMS shipping notifications
            </label>
          )}
        </FormCheckboxOption>
      </motion.div>

      <motion.div layout className="col-12">
        <ShippingNotifications />
      </motion.div>
    </>
  )
}

export default withNullErrorBoundary(ShippingOptions)
